// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/readiness/TenantReadinessPanel.jsx

import React from "react";
import MvpGateCard from "./MvpGateCard";
import ReadinessCheckList from "./ReadinessCheckList";

export default function TenantReadinessPanel({
  readiness,
  score,
  onRefresh,
  saving,
  refreshedAt,
}) {
  const gate = readiness?.mvp_gate;
  const checks = readiness?.checks || [];
  const blockers = readiness?.summary?.critical_blockers || [];
  const warnings = readiness?.summary?.warnings || [];

  return (
    <section className="enterprise-admin-form-card enterprise-admin-readiness-panel">
      <div className="enterprise-admin-card-heading">
        <p className="enterprise-admin-eyebrow">Operational Readiness</p>
        <h3>Launch readiness and open blockers</h3>
        <p>
          Confirm identity, administration, connector governance, and audit foundations before broad rollout.
        </p>
      </div>

      <MvpGateCard
        gate={gate}
        score={score}
        blockers={blockers}
        warnings={warnings}
        onRefresh={onRefresh}
        saving={saving}
        refreshedAt={refreshedAt}
      />

      <ReadinessCheckList checks={checks} />
    </section>
  );
}
